import Config from "./index";

const baseURL = Config.get("smartContract.API_URL");

// Dynamic function to get token from localStorage
const getToken = () => {
  return localStorage.getItem("UserToken") || localStorage.getItem("token") || "";
};

export const config = {
  // api's base url
  baseURL,
  // required headers - will be updated dynamically
  headers: {
    "Content-Type": "application/json",
  },
};

// Set initial token if available
const initialToken = getToken();
if (initialToken) {
  config.headers.Authorization = initialToken.includes("Bearer")
    ? initialToken
    : `Bearer ${initialToken}`;
}
